export default __webpack_public_path__ + "static/media/indonesia1.6ece5c81.jpg";